import { useMutation } from "react-query";
import { usePostAuthenticate } from "src/authentication/hooks/useAuthenticate";
import type {
  AuthenticationOtpCredentials,
  AuthenticationOtpResendToken,
  AuthenticationResultOtp,
  AuthenticationResultSuccess,
} from "src/authentication/objects/Authentication";
import { AUTHENTICATION_API_PATH } from "src/confs/APIConfig";
import { useApiPost } from "src/shared/actions/FetchActions";

export const useAuthenticateOtp = () => {
  const apiPost = useApiPost();
  const postAuthenticate = usePostAuthenticate();
  return useMutation(
    async (credentials: AuthenticationOtpCredentials) => {
      return await apiPost<AuthenticationResultSuccess>(
        `${AUTHENTICATION_API_PATH}/action/_otp.auth`,
        credentials,
      );
    },
    {
      onSuccess: async ({ data: authenticationResult }) => {
        await postAuthenticate(authenticationResult);
      },
    },
  );
};

export const useAuthenticateOtpResend = () => {
  const apiPost = useApiPost();
  return useMutation(async (request: AuthenticationOtpResendToken) => {
    const response = await apiPost<AuthenticationResultOtp>(
      `${AUTHENTICATION_API_PATH}/action/_otp.send`,
      request,
    );
    return response.data;
  });
};
